import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Chip, TableCell, TableRow } from "@mui/material";
import { statusChip, ticketNumberLabel } from "../../utils/inboxPresentation";
import { ticketLessonLabel } from "../../utils/studentDetail";
import { ticketReasonLine } from "../../utils/ticketDetail";
import { dateTimeLines } from "../../utils/kitPresentation";
import { tokens } from "../../utils/figmaTokens";
import { EyeButton, TwoLineCell } from "../../components/kit/TableParts";

// One ticket in a table (Tickets 10810:61045, 10821:93710): the number over the day it was
// raised, the reason over the lesson, the status chip, the last activity, and the eye that opens
// the ticket page (047 D54). The Inbox adds the RAISED BY cell (`raisedBy`, a node) and opens the
// ticket on a row click (`openOnClick`). Dates are the reader's; `timeZone` prints the lesson in
// the person's zone on their Tickets tab.
const TicketRow = ({ ticket, timeZone, raisedBy, canOpen = true, openOnClick = false }) => {
  const navigate = useNavigate();
  const to = `/inbox/${ticket.id}`;
  const number = ticketNumberLabel(ticket);
  const raised = dateTimeLines(ticket.raisedAt);
  const last = dateTimeLines(ticket.lastActivityAt || ticket.raisedAt);
  const chip = statusChip(ticket.status);
  const clickable = openOnClick && canOpen;
  return (
    <TableRow hover onClick={clickable ? () => navigate(to) : undefined} sx={clickable ? { cursor: "pointer" } : undefined}>
      <TableCell>
        <TwoLineCell
          top={
            <Box component="span" sx={{ color: number.muted ? tokens.text.tertiary : undefined }}>
              {number.label}
            </Box>
          }
          bottom={raised?.date}
        />
      </TableCell>
      <TableCell sx={{ minWidth: 220 }}>
        <TwoLineCell wrap top={ticketReasonLine(ticket)} bottom={ticketLessonLabel(ticket, { timeZone })} />
      </TableCell>
      {raisedBy && <TableCell>{raisedBy}</TableCell>}
      <TableCell>
        <Chip label={chip.label} color={chip.color} />
      </TableCell>
      <TableCell>
        <TwoLineCell top={last ? last.date : "-"} bottom={last?.time} />
      </TableCell>
      {/* The row opens the ticket; the eye must not open it a second time. */}
      <TableCell onClick={(e) => e.stopPropagation()}>
        {canOpen && <EyeButton to={to} label={`Open ticket ${number.label}`} />}
      </TableCell>
    </TableRow>
  );
};

export default TicketRow;
